<script>
    // import Modal from "carbon-components-svelte";
    import { Modal } from "carbon-components-svelte";
    let modal_now,
        modalTitle,
        modalMessage,
        open = false;
    const modal = (type, title, message) => {
        modal_now = type;
        modalTitle = title;
        modalMessage = message;
        open = true; // open modal message to user
    };
    export function modalAbout() {
        modal(
            "about",
            "FullControl",
            "FullControl is open-source design software created by Andrew Gleadall and Dirk Leas. It embraces the design principles of the original version ('FullControl GCode Designer'), but this second version ('FullControl') is entirely new - both technically and conceptually. This website allows anyone to use FullControl models without needing to understand how FullControl works. To create original designs in FullControl, see the GitHub repository."
        );
    }
    export function modalPython() {
        modal(
            "python",
            "FullControl (python)",
            "The python version of FullControl is available now and many of the models from this website are available there (more coming soon!) - this allows complete freedom to change all aspects of the design and reuse code in other designs"
        );
    }
    export function modalPythonOnLoad() {
        modal(
            "pythonOnLoad",
            "FullControl (python)",
            "The python version of FullControl is available now - check it out and create entirely new designs!"
        );
    }
    export function modalGcode() {
        modal(
            "passive",
            "Take care!",
            "GCode produced here is experimental. Preview it in a gcode viewer or slicer set up for your printer. FullControl authors take no responsibility for any bad outcomes. Unusual printing has unusual risks - be careful! Tag FullControlXYZ on social media with feedback, photos, etc."
        );
    }
</script>

{#if modal_now == "about"}
    <Modal
        primaryButtonText="FullControl python GitHub repository"
        secondaryButtonText="Original website: www.fullcontrolgcode.com"
        on:submit={() =>
            window.open(
                "https://github.com/FullControlXYZ/fullcontrol",
                "_blank"
            )}
        on:click:button--secondary={() =>
            window.open("http://www.fullcontrolgcode.com", "_blank")}
        bind:open
        modalHeading={modalTitle}
        on:open
        on:close
    >
        <p>
            {modalMessage}
        </p>
    </Modal>
{:else if modal_now == "passive"}
    <Modal passiveModal bind:open modalHeading={modalTitle} on:open on:close>
        <p>
            {modalMessage}
        </p>
    </Modal>
{:else if modal_now == "python"}
    <Modal
        primaryButtonText="FullControl GitHub (models page)"
        secondaryButtonText="FullControl GitHub (repository)"
        on:submit={() =>
            window.open(
                "https://github.com/FullControlXYZ/fullcontrol/tree/master/models",
                "_blank"
            )}
        on:click:button--secondary={() =>
            window.open(
                "https://github.com/FullControlXYZ/fullcontrol",
                "_blank"
            )}
        bind:open
        modalHeading={modalTitle}
        on:open
        on:close
    >
        <p>
            {modalMessage}
        </p>
    </Modal>
{:else if modal_now == "pythonOnLoad"}
    <Modal
        primaryButtonText="FullControl GitHub"
        on:submit={() =>
            window.open(
                "https://github.com/FullControlXYZ/fullcontrol",
                "_blank"
            )}
        bind:open
        modalHeading={modalTitle}
        on:open
        on:close
    >
        <p>
            {modalMessage}
        </p>
    </Modal>
{/if}
